import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "source", "style", "onScroll", "onMouseOver"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useImperativeHandle } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import Prism from 'prismjs';
import 'prismjs/components/prism-markup';
import { loadLang } from './langs';
import "./styles/markdown.css";
import "./styles/markdowncolor.css";
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ref = props || {},
      className = _ref.className,
      source = _ref.source,
      style = _ref.style,
      onScroll = _ref.onScroll,
      onMouseOver = _ref.onMouseOver,
      other = _objectWithoutProperties(_ref, _excluded);

  var mdp = /*#__PURE__*/React.createRef();
  var loadedLang = React.useRef(['markup']);
  useEffect(function () {
    highlight(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  function highlight() {
    return _highlight.apply(this, arguments);
  }

  function _highlight() {
    _highlight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var codes, _iterator, _step, val, tag, lang;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (mdp.current) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              codes = mdp.current.getElementsByTagName('code');
              _iterator = _createForOfIteratorHelper(codes);
              _context.prev = 4;

              _iterator.s();

            case 6:
              if ((_step = _iterator.n()).done) {
                _context.next = 24;
                break;
              }

              val = _step.value;
              tag = val.parentNode;

              if (!(tag && tag.tagName === 'PRE' && /^language-/.test(val.className.trim()))) {
                _context.next = 22;
                break;
              }

              lang = val.className.trim().replace(/^language-/, '');
              _context.prev = 11;

              if (loadedLang.current.includes(lang)) {
                _context.next = 16;
                break;
              }

              loadedLang.current.push(lang);
              _context.next = 16;
              return loadLang(lang);

            case 16:
              _context.next = 18;
              return Prism.highlightElement(val);

            case 18:
              _context.next = 22;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](11);

            case 22:
              _context.next = 6;
              break;

            case 24:
              _context.next = 29;
              break;

            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](4);

              _iterator.e(_context.t1);

            case 29:
              _context.prev = 29;

              _iterator.f();

              return _context.finish(29);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 26, 29, 32], [11, 20]]);
    }));
    return _highlight.apply(this, arguments);
  }

  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, props), {}, {
      lang: loadedLang.current,
      mdp: mdp
    });
  }, [mdp, props]);
  var cls = "wmde-markdown wmde-markdown-color ".concat(className || '');

  var reactMarkdownProps = _objectSpread(_objectSpread({
    allowDangerousHtml: true,
    allowNode: function allowNode(node, index, parent) {
      if (node.type === 'html' && reactMarkdownProps.allowDangerousHtml) {
        // filter style
        node.value = node.value.replace(/<((style|script|link|input|form)|\/(style|script|link|input|form))(\s?[^>]*>)/gi, function (a) {
          return a.replace(/[<>]/g, function (e) {
            return {
              '<': '&lt;',
              '>': '&gt;'
            }[e];
          });
        });
      }

      return true;
    }
  }, other), {}, {
    plugins: [gfm].concat(_toConsumableArray(other.plugins || [])),
    source: source || ''
  });

  return /*#__PURE__*/React.createElement("div", {
    ref: mdp,
    onScroll: onScroll,
    onMouseOver: onMouseOver,
    className: cls,
    style: style
  }, /*#__PURE__*/React.createElement(ReactMarkdown, reactMarkdownProps));
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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